<template>
  <help-text class="disclaimer">
    <p v-html="promotionText" />
  </help-text>
</template>

<script>
export default {
  name: 'how-it-works',
  inject: [
    'productName',
    'formMetadata',
  ],
  props: {
    companies: {
      type: Array,
      required: true,
    },
  },
  computed: {
    companiesNumberParsed () {
      const qty = this.companies.length;
      const floor5 = Math.floor(qty / 5) * 5;
      if (floor5 > 0) return `over ${floor5}`;
      return qty > 0 ? qty : '';
    },
    promotionText () {
      if (this.productName === 'life') {
        return '<strong>Let’s find you cover!</strong> We work with a range of life insurance specialists to help find you the right level of cover.';
      }

      return `<strong>Let's save some money!</strong>
              We work with ${this.companiesNumberParsed} ${this.formMetadata.productTitle.toLowerCase()} 
              insurance specialists to help find you the best deals!`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-lg {
    ol {
      list-style-type: decimal;
    }
  }
</style>
